import { Button, IconButton, styled } from '@mui/material';

const StyledDelete = styled(IconButton)(({ theme }) => ({
    '&:hover': {
      color: theme.palette.accentSecondary.main,
      backgroundColor: theme.palette.accentSecondary.accent20
    },
  }));

export default StyledDelete;